<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :onFetchData="onFetchData"
    :actions="[]"
    :batch-actions="batchActions"
    :actionButtons="[]"
    :form="form"
    :title="title || getTitle"
    namespace="plutus/"
    resource="entries"
    collapseFilter
  >
    <template #before-table>
      <el-table :data="[statistic]" style="flex: unset; margin-bottom: 10px;" v-if="showStatisticData">
        <el-table-column :label="$t('plutus_entries.balance_remain_amount')" prop="balance_remain_amount"></el-table-column>
        <el-table-column :label="$t('plutus_entries.topup_amount_from_agent')" prop="topup_amount_from_agent"></el-table-column>
        <el-table-column :label="$t('plutus_entries.total_transaction_volumn')" prop="total_transaction_volumn"></el-table-column>
        <el-table-column :label="$t('plutus_entries.withdraw_amount')" prop="withdraw_amount"></el-table-column>
      </el-table>
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import CommercialDocument from './commercial_document.vue';
import { COMMERCIAL_DOCUMENT_KIND } from '@/constants';
import _ from 'lodash';

@Component
export default class TransactionHistory extends Vue {
  @Prop(String) type;
  @Prop({ type: String, default: 'all' }) kind;
  @Prop(Number) miapayWalletHolderId;
  @Prop(String) title;

  // form 新建表单初始化数据（default数据）
  form = {}
  statistic = {
    balance_remain_amount: '',
    topup_amount_from_agent: 0,
    total_transaction_volumn: 0,
    withdraw_amount: ''
  };

  get getTitle() {
    switch (this.kind) {
      case 'P2P': {
        return 'P2P';
      }
      case 'P2M': {
        return 'P2M';
      }
      case 'red_packet': {
        return this.$t('menu.grab');
      }
      case 'cashback': {
        return this.$t('menu.cashback');
      }
    }
    return this.$t('menu.allTransactions');
  }

  get showStatisticData() {
    return this.kind === 'all';
  }

  async mounted() {
    if (this.showStatisticData) {
      const data = await this.$request.get('/plutus/entries/get_statistic_data', {
        params: {
          kind: this.kind,
          miapay_wallet_holder_id: this.miapayWalletHolderId || this.$route.query.miapay_wallet_holder_id
        } });
      this.statistic = data;
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'commercial_document_number_cont',
        label: this.$t('plutus_entries.number'),
        renderCell: {
          component: 'input'
        }
      },
      !this.miapayWalletHolderId && {
        prop: 'miapay_wallet_holder_id',
        label: this.$t('plutus_entries.user_or_agent_phone'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            xRemotePreload: async () => {
              const { data } = await this.$request.get('/miapay/wallet_holders/read_options', { params: { must_contain_id: this.$route.query.miapay_wallet_holder_id } });
              return _.map(data, ({ id, phone }) => ({ value: id, label: phone }));
            },
            xRemoteSearch: async (keyword) => {
              const { data } = await this.$request.get('/miapay/wallet_holders/read_options', { params: { keyword, must_contain_id: this.$route.query.miapay_wallet_holder_id } });
              return _.map(data, ({ id, phone }) => ({ value: id, label: phone }));
            }
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      this.kind === 'all' && {
        prop: 'commercial_document_kind_in',
        label: this.$t('plutus_entries.commercial_document_kind'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            multiple: true,
            options: _.map(COMMERCIAL_DOCUMENT_KIND, (label, value) => ({ value, label }))
          },
          domProps: {
            style: 'width: 100%'
          }
        }
      },
      {
        prop: 'commercial_document_id_eq',
        label: this.$t('plutus_entries.commercial_document_id'),
        renderCell: {
          component: 'input'
        }
      },
      !this.miapayWalletHolderId && {
        prop: 'target_type',
        label: this.$t('plutus_entries.target_type'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: [
              { label: this.$t('plutus_entries.user'), value: 'User' },
              { label: this.$t('plutus_entries.agent'), value: 'Agent' },
            ]
          }
        }
      },
      {
        prop: 'month',
        label: this.$t('plutus_entries.month'),
        renderCell: {
          component: 'datePicker',
          props: {
            type: 'month',
            valueFormat: 'yyyy-MM'
          }
        }
      },
      {
        prop: 'date_gteq',
        label: this.$t('plutus_entries.date_gteq'),
        renderCell: {
          component: 'datePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd'
          }
        }
      },
      {
        prop: 'date_lteq',
        label: this.$t('plutus_entries.date_lteq'),
        renderCell: {
          component: 'datePicker',
          props: {
            type: 'date',
            valueFormat: 'yyyy-MM-dd'
          }
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'commercial_document.number',
        minWidth: 120,
        label: this.$t('plutus_entries.number'),
      },
      {
        prop: 'commercial_document',
        label: this.$t('plutus_entries.commercial_document'),
        type: 'expand',
        width: 180,
        renderCell: (h, { props: { value } }) => {
          return <CommercialDocument data={value} />
        }
      },
      {
        prop: 'created_at',
        label: this.$t('plutus_entries.transaction_at'),
        minWidth: 160,
        renderCell: 'time',
      },
      {
        prop: 'commercial_document.amount_cents',
        minWidth: 130,
        label: this.$t('plutus_entries.amount_cents'),
      },
      {
        prop: 'commercial_document.cashback_amount_cents',
        minWidth: 130,
        label: this.$t('plutus_entries.cashback_amount_cents'),
      },
      {
        prop: 'commercial_document.creditor_type',
        minWidth: 170,
        label: this.$t('plutus_entries.creditor_type'),
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (value) {
            const { id, user_id, agent_id, phone } = _.get(row, 'commercial_document.creditor_miapay_wallet_holder', {});
            return (<div>
                <span>{value}</span>
                { user_id ? <bean-link KeepNode to={{ name: 'users.show', params: { id: user_id } }}>{` ${phone}`}</bean-link> : '' }
                { agent_id ? <bean-link KeepNode to={{ name: 'agents.show', params: { id: agent_id } }}>{` ${phone}`}</bean-link> : '' }
                { id === (this.miapayWalletHolderId || this.$route.query.miapay_wallet_holder_id) ?
                    <el-tooltip class="item" effect="light" content={this.$t('hint.currentUserOrAgent')} placement="top-start"><i class="el-icon-location"></i></el-tooltip> : ''
                }
              </div>);
          }
        }
      },
      {
        prop: 'commercial_document.debitor_type',
        minWidth: 170,
        label: this.$t('plutus_entries.debitor_type'),
        renderCell: (h, { props: { value, scope: { row } } }) => {
          if (value) {
            const { id, user_id, agent_id, phone } = _.get(row, 'commercial_document.debitor_miapay_wallet_holder', {});
            return (<div>
                <span>{value}</span>
                { user_id ? <bean-link KeepNode to={{ name: 'users.show', params: { id: user_id } }}>{` ${phone}`}</bean-link> : '' }
                { agent_id ? <bean-link KeepNode to={{ name: 'agents.show', params: { id: agent_id } }}>{` ${phone}`}</bean-link> : '' }
                { id === (this.miapayWalletHolderId || this.$route.query.miapay_wallet_holder_id) ?
                    <el-tooltip class="item" effect="light" content={this.$t('hint.currentUserOrAgent')} placement="top-start"><i class="el-icon-location"></i></el-tooltip> : ''
                }
              </div>);
          }
        }
      },
      {
        prop: 'commercial_document.kind',
        label: this.$t('plutus_entries.kind'),
        minWidth: 160,
        renderCell: (h, { props: { value } }) => {
          return <el-tag>{COMMERCIAL_DOCUMENT_KIND[value]}</el-tag>
        }
      },
      {
        prop: 'commercial_document.remark',
        minWidth: 120,
        label: this.$t('plutus_entries.remark')
      }
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'id',
        label: '编号',
        renderCell: {
          component: 'input',
          required: true
        }
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: '编辑',
          to: { name: 'entries.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: '删除',
          type: 'danger',
          can: 'entries.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
   batchActions({ selection }) {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/plutus/entries/export?kind=${this.kind}`,
          {
            ...this.$route.query,
            timezone,
            subject: this.getTitle,
            miapay_wallet_holder_id: this.miapayWalletHolderId,
            on_user_details_page: !!this.miapayWalletHolderId,
          });
      } else {
        await this.$request.get(`/plutus/entries/export?kind=${this.kind}`,
          {
            ...this.$route.query,
            timezone,
            subject: this.getTitle,
            miapay_wallet_holder_id: this.miapayWalletHolderId,
            on_user_details_page: !!this.miapayWalletHolderId,
            id_in: _.map(selection, item => item.id)
          });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i> {this.$t('bean.actionExport')}</el-button>
    ];
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      let params = { ...this.$route.query, kind: this.kind };
      if (this.miapayWalletHolderId) {
        params.miapay_wallet_holder_id = this.miapayWalletHolderId;
      }
      if (params.target_type === '') {
        params.target_type = undefined;
      }
      const { data, pagination } = await this.$request.get('/plutus/entries', { params });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/plutus/entries/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {}
    }
  }
}


export const route = [
  {
    path: '/transaction_history',
    name: 'transaction_history.index',
    component: TransactionHistory,
    props: {
      type: 'index',
    },
    meta: {
      can: 'plutus_entries.read'
    }
  },
  {
    path: '/transaction_history/:id',
    name: 'transaction_history.show',
    component: TransactionHistory,
    props: {
      type: 'show',
    },
    meta: {
      can: 'plutus_entries.read'
    }
  },
  {
    path: '/transaction_history_p2p',
    name: 'transaction_history_p2p.index',
    component: TransactionHistory,
    props: {
      type: 'index',
      kind: 'P2P'
    },
    meta: {
      can: 'plutus_entries.read'
    }
  },
  {
    path: '/transaction_history_p2m',
    name: 'transaction_history_p2m.index',
    component: TransactionHistory,
    props: {
      type: 'index',
      kind: 'P2M'
    },
    meta: {
      can: 'plutus_entries.read'
    }
  },
  {
    path: '/transaction_history_red_packet',
    name: 'transaction_history_red_packet.index',
    component: TransactionHistory,
    props: {
      type: 'index',
      kind: 'red_packet'
    },
    meta: {
      can: 'plutus_entries.read'
    }
  },
  {
    path: '/transaction_history_cashback',
    name: 'transaction_history_cashback.index',
    component: TransactionHistory,
    props: {
      type: 'index',
      kind: 'cashback'
    },
    meta: {
      can: 'plutus_entries.read'
    }
  },
]
</script>
